module.exports = __webpack_public_path__ + "images/emoji/movie_camera.4833988a93d17d4fb0ba.png";